import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

import NoticeContent from "./NoticeContent";
import PausedContent from "./PausedContent";
import StoppedContent from "./StoppedContent";

PopoverContent.propTypes = {
  status: PropTypes.string,
  paymentType: PropTypes.string,
  nextPaymentDate: PropTypes.string,
  ID: PropTypes.number,
  failedPaymentsCount: PropTypes.number,
  lastConsecutiveFailedPayments: PropTypes.array,
  handleClose: PropTypes.func,
};

export default function PopoverContent({
  status,
  paymentType,
  nextPaymentDate,
  ID,
  failedPaymentsCount,
  lastConsecutiveFailedPayments,
  handleClose,
}) {
  const history = useHistory();
  const location = useLocation();

  const openEditModal = () => {
    handleClose();
    history.push(`${location.pathname}/recurring/${ID}`);
  };

  return (
    <>
      {status === "paused" && (
        <PausedContent
          paymentType={paymentType}
          nextPaymentDate={nextPaymentDate}
          ID={ID}
          handleClose={handleClose}
        />
      )}
      {status === "stopped" && (
        <StoppedContent
          paymentType={paymentType}
          nextPaymentDate={nextPaymentDate}
          handleClose={handleClose}
          openEditModal={openEditModal}
        />
      )}
      {status === "active" && failedPaymentsCount === 1 && (
        <NoticeContent
          paymentType={paymentType}
          nextPaymentDate={nextPaymentDate}
          lastConsecutiveFailedPayments={lastConsecutiveFailedPayments}
          handleClose={handleClose}
          openEditModal={openEditModal}
        />
      )}
    </>
  );
}
